import InteresseEducacionalList from './list';

export default function InteresseEducacionalPage() {
  return <InteresseEducacionalList />;
}
